"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Countries = void 0;
exports.Countries = [
    [
        'AC',
        247,
        'ASC',
    ],
    [
        'AD',
        376,
        'AND',
    ],
    [
        'AE',
        971,
        'ARE',
    ],
    [
        'AF',
        93,
        'AFG',
    ],
    [
        'AQ',
        672,
        'ATA',
    ],
    [
        'AG',
        1,
        'ATG',
    ],
    [
        'AI',
        1,
        'AIA',
    ],
    [
        'AL',
        355,
        'ALB',
    ],
    [
        'AM',
        374,
        'ARM',
    ],
    [
        'AO',
        244,
        'AGO',
    ],
    [
        'AR',
        54,
        'ARG',
    ],
    [
        'AS',
        1,
        'ASM',
    ],
    [
        'AT',
        43,
        'AUT',
    ],
    [
        'AU',
        61,
        'AUS',
    ],
    [
        'AW',
        297,
        'ABW',
    ],
    [
        'AX',
        358,
        'ALA',
    ],
    [
        'AZ',
        994,
        'AZE',
    ],
    [
        'BA',
        387,
        'BIH',
    ],
    [
        'BB',
        1,
        'BRB',
    ],
    [
        'BD',
        880,
        'BGD',
    ],
    [
        'BE',
        32,
        'BEL',
    ],
    [
        'BF',
        226,
        'BFA',
    ],
    [
        'BG',
        359,
        'BGR',
    ],
    [
        'BH',
        973,
        'BHR',
    ],
    [
        'BI',
        257,
        'BDI',
    ],
    [
        'BJ',
        229,
        'BEN',
    ],
    [
        'BL',
        590,
        'BLM',
    ],
    [
        'BM',
        1,
        'BMU',
    ],
    [
        'BN',
        673,
        'BRN',
    ],
    [
        'BO',
        591,
        'BOL',
    ],
    [
        'BQ',
        599,
        'BES',
    ],
    [
        'BR',
        55,
        'BRA',
    ],
    [
        'BS',
        1,
        'BHS',
    ],
    [
        'BT',
        975,
        'BTN',
    ],
    [
        'BW',
        267,
        'BWA',
    ],
    [
        'BY',
        375,
        'BLR',
    ],
    [
        'BZ',
        501,
        'BLZ',
    ],
    [
        'CA',
        1,
        'CAN',
    ],
    [
        'CC',
        61,
        'CCK',
    ],
    [
        'CD',
        243,
        'COD',
    ],
    [
        'CF',
        236,
        'CAF',
    ],
    [
        'CG',
        242,
        'COG',
    ],
    [
        'CH',
        41,
        'CHE',
    ],
    [
        'CI',
        225,
        'CIV',
    ],
    [
        'CK',
        682,
        'COK',
    ],
    [
        'CL',
        56,
        'CHL',
    ],
    [
        'CM',
        237,
        'CMR',
    ],
    [
        'CN',
        86,
        'CHN',
    ],
    [
        'CO',
        57,
        'COL',
    ],
    [
        'CR',
        506,
        'CRI',
    ],
    [
        'CU',
        53,
        'CUB',
    ],
    [
        'CV',
        238,
        'CPV',
    ],
    [
        'CW',
        599,
        'CUW',
    ],
    [
        'CX',
        61,
        'CXR',
    ],
    [
        'CY',
        357,
        'CYP',
    ],
    [
        'CZ',
        420,
        'CZE',
    ],
    [
        'DE',
        49,
        'DEU',
    ],
    [
        'DG',
        246,
        'DGA',
    ],
    [
        'DJ',
        253,
        'DJI',
    ],
    [
        'DK',
        45,
        'DNK',
    ],
    [
        'DM',
        1,
        'DMA',
    ],
    [
        'DO',
        1,
        'DOM',
    ],
    [
        'DZ',
        213,
        'DZA',
    ],
    [
        'EC',
        593,
        'ECU',
    ],
    [
        'EE',
        372,
        'EST',
    ],
    [
        'EG',
        20,
        'EGY',
    ],
    [
        'EH',
        212,
        'ESH',
    ],
    [
        'ER',
        291,
        'ERI',
    ],
    [
        'ES',
        34,
        'ESP',
    ],
    [
        'ET',
        251,
        'ETH',
    ],
    [
        'FI',
        358,
        'FIN',
    ],
    [
        'FJ',
        679,
        'FJI',
    ],
    [
        'FK',
        500,
        'FLK',
    ],
    [
        'FM',
        691,
        'FSM',
    ],
    [
        'FO',
        298,
        'FRO',
    ],
    [
        'FR',
        33,
        'FRA',
    ],
    [
        'GA',
        241,
        'GAB',
    ],
    [
        'GB',
        44,
        'GBR',
    ],
    [
        'GD',
        1,
        'GRD',
    ],
    [
        'GE',
        995,
        'GEO',
    ],
    [
        'GF',
        594,
        'GUF',
    ],
    [
        'GG',
        44,
        'GGY',
    ],
    [
        'GH',
        233,
        'GHA',
    ],
    [
        'GI',
        350,
        'GIB',
    ],
    [
        'GL',
        299,
        'GRL',
    ],
    [
        'GM',
        220,
        'GMB',
    ],
    [
        'GN',
        224,
        'GIN',
    ],
    [
        'GP',
        590,
        'GLP',
    ],
    [
        'GQ',
        240,
        'GNQ',
    ],
    [
        'GR',
        30,
        'GRC',
    ],
    [
        'GT',
        502,
        'GTM',
    ],
    [
        'GU',
        1,
        'GUM',
    ],
    [
        'GW',
        245,
        'GNB',
    ],
    [
        'GY',
        592,
        'GUY',
    ],
    [
        'HK',
        852,
        'HKG',
    ],
    [
        'HN',
        504,
        'HND',
    ],
    [
        'HR',
        385,
        'HRV',
    ],
    [
        'HT',
        509,
        'HTI',
    ],
    [
        'HU',
        36,
        'HUN',
    ],
    [
        'ID',
        62,
        'IDN',
    ],
    [
        'IE',
        353,
        'IRL',
    ],
    [
        'IL',
        972,
        'ISR',
    ],
    [
        'IM',
        44,
        'IMN',
    ],
    [
        'IN',
        91,
        'IND',
    ],
    [
        'IO',
        246,
        'IOT',
    ],
    [
        'IQ',
        964,
        'IRQ',
    ],
    [
        'IR',
        98,
        'IRN',
    ],
    [
        'IS',
        354,
        'ISL',
    ],
    [
        'IT',
        39,
        'ITA',
    ],
    [
        'JE',
        44,
        'JEY',
    ],
    [
        'JM',
        1,
        'JAM',
    ],
    [
        'JO',
        962,
        'JOR',
    ],
    [
        'JP',
        81,
        'JPN',
    ],
    [
        'KE',
        254,
        'KEN',
    ],
    [
        'KG',
        996,
        'KGZ',
    ],
    [
        'KH',
        855,
        'KHM',
    ],
    [
        'KI',
        686,
        'KIR',
    ],
    [
        'KM',
        269,
        'COM',
    ],
    [
        'KN',
        1,
        'KNA',
    ],
    [
        'KP',
        850,
        'PRK',
    ],
    [
        'KR',
        82,
        'KOR',
    ],
    [
        'KW',
        965,
        'KWT',
    ],
    [
        'KY',
        1,
        'CYM',
    ],
    [
        'KZ',
        7,
        'KAZ',
    ],
    [
        'LA',
        856,
        'LAO',
    ],
    [
        'LB',
        961,
        'LBN',
    ],
    [
        'LC',
        1,
        'LCA',
    ],
    [
        'LI',
        423,
        'LIE',
    ],
    [
        'LK',
        94,
        'LKA',
    ],
    [
        'LR',
        231,
        'LBR',
    ],
    [
        'LS',
        266,
        'LSO',
    ],
    [
        'LT',
        370,
        'LTU',
    ],
    [
        'LU',
        352,
        'LUX',
    ],
    [
        'LV',
        371,
        'LVA',
    ],
    [
        'LY',
        218,
        'LBY',
    ],
    [
        'LX',
        218,
        'LXX',
    ],
    [
        'MA',
        212,
        'MAR',
    ],
    [
        'MC',
        377,
        'MCO',
    ],
    [
        'MD',
        373,
        'MDA',
    ],
    [
        'ME',
        382,
        'MNE',
    ],
    [
        'MF',
        590,
        'MAF',
    ],
    [
        'MG',
        261,
        'MDG',
    ],
    [
        'MH',
        692,
        'MHL',
    ],
    [
        'MK',
        389,
        'MKD',
    ],
    [
        'ML',
        223,
        'MLI',
    ],
    [
        'MM',
        95,
        'MMR',
    ],
    [
        'MN',
        976,
        'MNG',
    ],
    [
        'MO',
        853,
        'MAC',
    ],
    [
        'MP',
        1,
        'MNP',
    ],
    [
        'MQ',
        596,
        'MTQ',
    ],
    [
        'MR',
        222,
        'MRT',
    ],
    [
        'MS',
        1,
        'MSR',
    ],
    [
        'MT',
        356,
        'MLT',
    ],
    [
        'MU',
        230,
        'MUS',
    ],
    [
        'MV',
        960,
        'MDV',
    ],
    [
        'MW',
        265,
        'MWI',
    ],
    [
        'MX',
        52,
        'MEX',
    ],
    [
        'MY',
        60,
        'MYS',
    ],
    [
        'MZ',
        258,
        'MOZ',
    ],
    [
        'NA',
        264,
        'NAM',
    ],
    [
        'NC',
        687,
        'NCL',
    ],
    [
        'NE',
        227,
        'NER',
    ],
    [
        'NF',
        672,
        'NFK',
    ],
    [
        'NG',
        234,
        'NGA',
    ],
    [
        'NI',
        505,
        'NIC',
    ],
    [
        'NL',
        31,
        'NLD',
    ],
    [
        'NO',
        47,
        'NOR',
    ],
    [
        'NP',
        977,
        'NPL',
    ],
    [
        'NR',
        674,
        'NRU',
    ],
    [
        'NU',
        683,
        'NIU',
    ],
    [
        'NZ',
        64,
        'NZL',
    ],
    [
        'OM',
        968,
        'OMN',
    ],
    [
        'PA',
        507,
        'PAN',
    ],
    [
        'PE',
        51,
        'PER',
    ],
    [
        'PF',
        689,
        'PYF',
    ],
    [
        'PG',
        675,
        'PNG',
    ],
    [
        'PH',
        63,
        'PHL',
    ],
    [
        'PK',
        92,
        'PAK',
    ],
    [
        'PL',
        48,
        'POL',
    ],
    [
        'PM',
        508,
        'SPM',
    ],
    [
        'PR',
        1,
        'PRI',
    ],
    [
        'PS',
        970,
        'PSE',
    ],
    [
        'PT',
        351,
        'PRT',
    ],
    [
        'PW',
        680,
        'PLW',
    ],
    [
        'PY',
        595,
        'PRY',
    ],
    [
        'QA',
        974,
        'QAT',
    ],
    [
        'RE',
        262,
        'REU',
    ],
    [
        'RO',
        40,
        'ROU',
    ],
    [
        'RS',
        381,
        'SRB',
    ],
    [
        'RU',
        7,
        'RUS',
    ],
    [
        'RW',
        250,
        'RWA',
    ],
    [
        'SA',
        966,
        'SAU',
    ],
    [
        'SB',
        677,
        'SLB',
    ],
    [
        'SC',
        248,
        'SYC',
    ],
    [
        'SD',
        249,
        'SDN',
    ],
    [
        'SE',
        46,
        'SWE',
    ],
    [
        'SG',
        65,
        'SGP',
    ],
    [
        'SH',
        290,
        'SHN',
    ],
    [
        'SI',
        386,
        'SVN',
    ],
    [
        'SJ',
        47,
        'SJM',
    ],
    [
        'SK',
        421,
        'SVK',
    ],
    [
        'SL',
        232,
        'SLE',
    ],
    [
        'SM',
        378,
        'SMR',
    ],
    [
        'SN',
        221,
        'SEN',
    ],
    [
        'SO',
        252,
        'SOM',
    ],
    [
        'SR',
        597,
        'SUR',
    ],
    [
        'SS',
        211,
        'SSD',
    ],
    [
        'ST',
        239,
        'STP',
    ],
    [
        'SV',
        503,
        'SLV',
    ],
    [
        'SX',
        1,
        'SXM',
    ],
    [
        'SY',
        963,
        'SYR',
    ],
    [
        'SZ',
        268,
        'SWZ',
    ],
    [
        'TA',
        290,
        'TAA',
    ],
    [
        'TC',
        1,
        'TCA',
    ],
    [
        'TD',
        235,
        'TCD',
    ],
    [
        'TG',
        228,
        'TGO',
    ],
    [
        'TH',
        66,
        'THA',
    ],
    [
        'TJ',
        992,
        'TJK',
    ],
    [
        'TK',
        690,
        'TKL',
    ],
    [
        'TL',
        670,
        'TLS',
    ],
    [
        'TM',
        993,
        'TKM',
    ],
    [
        'TN',
        216,
        'TUN',
    ],
    [
        'TO',
        676,
        'TON',
    ],
    [
        'TP',
        670,
        'TMP',
    ],
    [
        'TR',
        90,
        'TUR',
    ],
    [
        'TT',
        1,
        'TTO',
    ],
    [
        'TV',
        688,
        'TUV',
    ],
    [
        'TW',
        886,
        'TWN',
    ],
    [
        'TZ',
        255,
        'TZA',
    ],
    [
        'UA',
        380,
        'UKR',
    ],
    [
        'UG',
        256,
        'UGA',
    ],
    [
        'US',
        1,
        'USA',
    ],
    [
        'UY',
        598,
        'URY',
    ],
    [
        'UZ',
        998,
        'UZB',
    ],
    [
        'VA',
        39,
        'VAT',
    ],
    [
        'VC',
        1,
        'VCT',
    ],
    [
        'VE',
        58,
        'VEN',
    ],
    [
        'VG',
        1,
        'VGB',
    ],
    [
        'VI',
        1,
        'VIR',
    ],
    [
        'VN',
        84,
        'VNM',
    ],
    [
        'VU',
        678,
        'VUT',
    ],
    [
        'WF',
        681,
        'WLF',
    ],
    [
        'WS',
        685,
        'WSM',
    ],
    [
        'XK',
        383,
        'XXK',
    ],
    [
        'YE',
        967,
        'YEM',
    ],
    [
        'YT',
        262,
        'MYT',
    ],
    [
        'ZA',
        27,
        'ZAF',
    ],
    [
        'ZM',
        260,
        'ZMB',
    ],
    [
        'ZW',
        263,
        'ZWE',
    ],
];
